import React from 'react'

const MaterialCheckBox = () => {
  return (
    <div className='svg-icon material-checkbox-icon'>
    <svg  data-name="Icon material-check-box" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
      <path data-name="Icon material-check-box" d="M28.5,4.5H7.5a3,3,0,0,0-3,3v21a3,3,0,0,0,3,3h21a3,3,0,0,0,3-3V7.5A3,3,0,0,0,28.5,4.5ZM15,25.5,7.5,18l2.115-2.115L15,21.255,26.385,9.87,28.5,12Z" transform="translate(-4.5 -4.5)" fill="#48cb6e"/>
    </svg>

    </div>
  )
}

export default MaterialCheckBox
